<template>
    <div class="app-view-header bg-primary-20">
        <slot />
    </div>
</template>
